<div class="download-form-wrapper pb-5">
  <div class="card-body pb-0">
    <div class="card-title row justify-content-between align-items-center">
      <h4 class="m-0 header-title">Change Password</h4>
    </div>

    <div class="w-100">
      <div class="">
        <div class="consent-container">
          <form [formGroup]="form" (ngSubmit)="close()" novalidate class="enforce-password-change-form">

            <div class="enforce-password-change-field">
              <input type="password" formControlName="oldPass" class="loginFeilds" placeholder="Old Password*"
                autocomplete="off">
              <div class="error" *ngIf="form.get('oldPass')?.touched && form.get('oldPass').hasError('required')">This
                is required</div>
            </div>

            <div class="enforce-password-change-field">
              <input type="password" formControlName="newPass" class="loginFeilds" placeholder="New Password*"
                autocomplete="off">
              <div class="error" *ngIf="form.get('newPass')?.touched && form.get('newPass').hasError('required')">This
                is required.</div>
              <div class="error" *ngIf="form.get('newPass')?.touched && form.get('newPass').hasError('pattern')">
                Password must be at least 14 characters long and include uppercase and lowercase letters, a number, and
                a special character.</div>

            </div>

            <div class="enforce-password-change-field">
              <input type="password" formControlName="confirmPass" class="loginFeilds"
                placeholder="Confirm New Password*" autocomplete="off">
              <div class="error" *ngIf="confirmPassError">{{ confirmPassError }}</div>
              <div class="error"
                *ngIf="form.get('confirmPass')?.touched && form.get('confirmPass').hasError('required')">This is
                required.</div>
              <div class="error"
                *ngIf="form.get('confirmPass')?.touched && form.get('confirmPass').hasError('passwordMismatch')">Passwords do
                not match.</div>
            </div>
            <span *ngIf="error && !isPasswordChangedSuccessfully" style="color: red; display: flex;
            justify-content: center;">{{error.error }}</span>
              <span *ngIf="isPasswordChangedSuccessfully" style="color: green;">Your Password has been changed Successfully!! <br>
              Please click "OK" to login with your new password</span> 
            <div class="enforce-password-change-field">
              <input class="btn btn-primary px-3" [disabled]="form.invalid" type="submit" [value]="isPasswordChangedSuccessfully ? 'OK' : 'Submit'">
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>